export const interpolate = (x, x1, y1, x2, y2) => {
    if (x1 === x2) return y1;
    return y1 + (x - x1) * (y2 - y1) / (x2 - x1);
};

export const findValuesInRange = (ptv, rangeData) => {
    if (!rangeData || rangeData.length === 0) return undefined;
    return rangeData.find(row => {
        const min = parseFloat(row.ptvMin);
        const max = parseFloat(row.ptvMax);
        if (!isNaN(min) && (isNaN(max) || max === null || max === '')) {
            return ptv >= min;
        }
        return ptv >= min && ptv <= max;
    });
};